

export const Home =()=>{


    return (<div className="bcgHome"> <section id="home-page" className="home-bcg">
    <div className="center">
      <h1 className="KD">
        Kiril &amp; Danny
      </h1>
      <br />
      <h2>Are getting married</h2>
      <br />
      <h2>
        <b>14.12.2019</b>
      </h2>
    </div>
  </section>
  </div>
  )
}